function MyPage() {
  return (
    <svg
      width='19'
      height='20'
      viewBox='0 0 19 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.38867 12.3291H11.6113C15.2723 12.3292 18.2499 15.3015 18.25 18.9473V19.25H0.75V18.9473C0.750056 15.3014 3.72668 12.3292 7.38867 12.3291ZM9.5 0.75C11.7066 0.75 13.5 2.5419 13.5 4.7373C13.4997 6.9325 11.7064 8.72363 9.5 8.72363C7.29357 8.72363 5.50025 6.9325 5.5 4.7373C5.5 2.5419 7.29342 0.75 9.5 0.75Z'
        stroke='#949494'
        stroke-width='1.5'
      />
    </svg>
  );
}

function ActiveMyPage() {
  return (
    <svg
      width='19'
      height='20'
      viewBox='0 0 19 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.38867 12.3291H11.6113C15.2723 12.3292 18.2499 15.3015 18.25 18.9473V19.25H0.75V18.9473C0.750056 15.3014 3.72668 12.3292 7.38867 12.3291ZM9.5 0.75C11.7066 0.75 13.5 2.5419 13.5 4.7373C13.4997 6.9325 11.7064 8.72363 9.5 8.72363C7.29357 8.72363 5.50025 6.9325 5.5 4.7373C5.5 2.5419 7.29342 0.75 9.5 0.75Z'
        fill='#3A3A3A'
        stroke='#3A3A3A'
        stroke-width='1.5'
      />
    </svg>
  );
}

export { MyPage, ActiveMyPage };
